import { render } from "./DirectionIndicator.vue?vue&type=template&id=16725439&scoped=true"
import script from "./DirectionIndicator.vue?vue&type=script&lang=ts"
export * from "./DirectionIndicator.vue?vue&type=script&lang=ts"

import "./DirectionIndicator.vue?vue&type=style&index=0&id=16725439&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16725439"

export default script